import request from "superagent";
import { BACKEND_URL } from "../config/config";

let auth: { GKT?: string } = {};

export function getAuth() {
  return auth;
}

export async function fetchAdaptiveBaatToken() {
  return new Promise((resolve, reject) => {
    request
      .get(BACKEND_URL + "WebServices/generic/Baat.ashx")
      .set("Accept", "application/json")
      .then((res) => {
        if (res.body.success && res.body.token) {
          auth = { GKT: res.body.token };
          resolve(auth);
        } else {
          console.error("Could not load BAAT token");
          reject();
        }
      })
      .catch((err) => {
        console.error("Could not load BAAT token", err);
        reject();
      });
  });
}
